import React from 'react';
import PropTypes from 'prop-types';

import {Button, Typography, Stack, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Translate} from 'views/module';

const AdminClockOutEvent = (props) => {
  const {closeModel, event, onAdminClockOut} = props;
  const [isSaving, setIsSaving] = React.useState(false);

  const caregiverName = event.caregiverData?.caregiverDetail?.caregiverName;

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    await onAdminClockOut(
        event.eventRn,
        () => {
          closeModel(true);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='schedule.eventDetail.AdminClockOutDialog.Title'/>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            <Translate expression='schedule.eventDetail.AdminClockOutDialog.Description' substitute={{caregiverName}}/>
          </Typography>
          <Typography
            variant="body2"
            sx={{
              background: '#e8f5e9',
              border: '1px solid #34A853',
              borderRadius: 2,
              color: '#1e8e3e',
              px: 1.5,
              py: 1,
            }}
          >
            <Translate expression='schedule.eventDetail.AdminClockOutDialog.Note'/>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={onSave} disabled={isSaving}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AdminClockOutEvent.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onAdminClockOut: PropTypes.func.isRequired,
};

export default AdminClockOutEvent;
